import type { Account } from '../../../../accounts'

export interface UsersPageProps {
  accounts?: import('../../../../accounts').AccountsState
  getLearnerData?: (
    learnerId: string,
  ) => import('../../../../app/types').AppState | null
  getLearnerModuleMastery?: (
    learnerId: string,
    moduleId: import('../../../../content').ModuleId,
  ) => number
  onNavigateToLearner?: (learnerId: string) => void
}

export type RoleFilter =
  | 'all'
  | 'learner'
  | 'teacher'
  | 'parent'
  | 'admin'
  | 'school'

export interface FamilyMasteryEntry {
  masteryScore: number
  attempts: number
  familyId: string
}

export interface UserRow {
  id: string
  name: string
  email: string
  role: 'learner' | 'teacher' | 'parent' | 'admin'
  organization: string
  linkedCount: number
  xp: number
  lastActive: number
  lastActiveFormatted: string
  status: 'active' | 'inactive'
  account?: Account
  avgMastery?: number
  sessionCount?: number
  groupName?: string
  familyMastery?: Record<string, FamilyMasteryEntry>
}

export interface SchoolData {
  name: string
  learnerCount: number
  teacherCount: number
  avgMastery: number
  learners: UserRow[]
  teachers: UserRow[]
}

export const ROLE_CONFIG = {
  learner: {
    label: 'Leerling',
    variant: 'info' as const,
    icon: 'Users',
  },
  teacher: {
    label: 'Docent',
    variant: 'secondary' as const,
    icon: 'GraduationCap',
  },
  parent: {
    label: 'Ouder',
    variant: 'success' as const,
    icon: 'Heart',
  },
  admin: {
    label: 'Admin',
    variant: 'warning' as const,
    icon: 'Shield',
  },
} as const

export type RoleConfigKey = keyof typeof ROLE_CONFIG
